import { createContext, useContext } from 'react';

/**
 * False while the DockedPanel around this component slides out. DockedPanel
 * provides it; anything outside a panel reads true. Escape registrations
 * (escapeStack.ts) and the plan panels' own keydown listeners read it, so a
 * surface that is leaving stops answering Escape the moment `shown` flips,
 * instead of holding its layer for the 150ms exit.
 */
export const PanelShownContext = createContext(true);

export function usePanelShown(): boolean {
  return useContext(PanelShownContext);
}
